<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path d="M9 3.5L3 9.5M3 3.5L9 9.5" stroke="#E74C3C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>